import { Media } from "@/payload-types"

export const isVideoMedia = (media: Media | null) => {
    return media?.mimeType?.includes('video') || false
}